import { Column } from '@components/Table/model/table';
import { sortByName } from '@utils/utils';

const demandReportHeaderList: Column[] = [
  {
    name: 'Name',
    key: 'name',
    sortMethod: sortByName,
    width: '20%',
    sortable: true,
  },
  {
    name: 'Email',
    key: 'email',
    sortMethod: sortByName,
    width: '20%',
    sortable: true,
  },
  {
    name: 'Demands Basic',
    key: 'demands_basic',
    sortMethod: sortByName,
    width: '20%',
    sortable: true,
  },
  {
    name: 'Demands Files',
    key: 'demands_files',
    sortMethod: sortByName,
    width: '20%',
    sortable: true,
  },
  {
    name: 'Depositions',
    key: 'depositions',
    sortMethod: sortByName,
    width: '20%',
    sortable: true,
  },
];

const getDemandReportHeaderList = () => demandReportHeaderList;

export default getDemandReportHeaderList;
